import { createContext, Context } from 'react';
import type ObjectReference from './interfaces/ObjectReference';
import isObjectReference from './utils/isObjectReference';

export interface ObjectReferenceContext extends Context<ObjectReference> {
  displayName: 'ObjectReference';
}

export const defaultObjectReference: ObjectReference = {
  isObjectReference,
  dereference: () => null,
  responseSchemas: new Set(),
  addResponseSchema: () => null,
};

const objectReferenceContext = createContext<ObjectReference>(defaultObjectReference);
objectReferenceContext.displayName = 'ObjectReference';

export default objectReferenceContext;
